const Dashboard = require("./containers/Dashboard");
const AuthenticateAdmin = require("../utils").authenticateAdmin;

// Sync route definition
module.exports = {
    path: "/admin",
    component: AuthenticateAdmin(Dashboard),
    exact: true
};



// WEBPACK FOOTER //
// ./src/routes/admin-dashboard/index.js